module.exports = __webpack_public_path__ + "img/logo.d5902416.png";